// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__LxmDA","containerItemsCenter":"Skeleton_containerItemsCenter__3sE7R"};